export const PUG_CLOUD_ID = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
export const HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';

export const getEnvironment = (cloudId?: string) => {
	switch (cloudId) {
		case '':
		case undefined:
			return 'none';
		case PUG_CLOUD_ID:
			return 'pug';
		case HELLO_CLOUD_ID:
			return 'hello';
		default:
			return 'production';
	}
};
